import { render, staticRenderFns } from "./Sellers.vue?vue&type=template&id=5c7e9a8b&scoped=true&"
import script from "./Sellers.vue?vue&type=script&lang=ts&"
export * from "./Sellers.vue?vue&type=script&lang=ts&"
import style0 from "./Sellers.vue?vue&type=style&index=0&id=5c7e9a8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e9a8b",
  null
  
)

export default component.exports